import { Injectable } from "@angular/core";
import { Firestore, doc, docData, setDoc } from '@angular/fire/firestore';
import { Observable } from "rxjs";
import { AnnualRegistrationForm } from "./inscription.model";

@Injectable({
  providedIn: 'root',
})
export class InscriptionFirebaseService {

  private registrationCollectionName = 'annual-registration-forms';

  constructor(private firestore: Firestore) { }

getInscriptionFormDatas(
  memberId: string,
  year: number
): Observable<AnnualRegistrationForm> {

  const memberDocRef = doc(
    this.firestore,
    `${this.registrationCollectionName}/${year}/members/${memberId}`
  );

  return docData(memberDocRef) as Observable<AnnualRegistrationForm>;
}

updateCurrentInscription(
  memberId: string,
  formData: AnnualRegistrationForm,
  year: number
) {
  // Remove undefined values
  const cleanedFormData = JSON.parse(JSON.stringify(formData));

  // Build the document reference
  const memberDocRef = doc(
    this.firestore,
    `${this.registrationCollectionName}/${year}/members/${memberId}`
  );

  // Write the data
  return setDoc(memberDocRef, cleanedFormData);
}
}